<div class="line">
  <div class="line_label">Item ID</div>
  <div class="line_label">Qty</div>
</div>

<div class="line" *ngFor="let item of formArray.controls; let i = index">
  <ng-container [formGroup]="item">
    <div class="line_input">
      <div class="input-container">
        <input
          type="text"
          placeholder="Pick one"
          aria-label="Number"
          class="input-container_input"
          formControlName="item"
          [matAutocomplete]="auto"
          (click)="setScroll(i)"
        />
        <mat-autocomplete 
          #auto="matAutocomplete"
          autoActiveFirstOption
          [displayWith]="displayFn"
        >
          <mat-option
            *ngFor="let option of fitleredItemsOptions[i]"
            [value]="option"
            class="mat-option-override"
          >
            <app-item-typeahead
              [name]="option.title"
              [id]="option.name"
              [image]="option.imageUrl"
            ></app-item-typeahead>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="line_input">
      <div class="input-container">
        <input
          type="number"
          class="input-container_input"
          formControlName="qty"
        />
      </div>
    </div>
  </ng-container>
  <div class="line_action" (click)="removeMapping(i)">
    <i class="fal fa-times-circle"></i>
  </div>
<div class="add-Product"> <span *ngIf="formArray.controls[i].get('hasProduct').value">
    No product found 
  </span>
  <span><a href="javascript:void(0)" class="primary_color" (click)="createProduct(i)">Create New Product</a>
 </span>
</div>
</div>

<div class="add-item">
  <app-button (click)="addMapping()" [buttonSize]="'action'">
    <i class="fal fa-plus"></i> Add Item</app-button
  >
</div>

<div class="actions">
  <app-button (click)="cancel()">Cancel</app-button>
  <app-button [isDisabled]="!formArray.valid" (click)="saveMapping()" [spin]="loader"
    >Save</app-button
  >
</div>
